// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, intlShape } from 'react-intl';
import routes from '../../../../../routes';
import queryString from 'query-string';
import moment from 'moment';

import style from './CheckoutAsyncCommon.scss';
import yogiLeg from '../../../../../assets/img/YOGI-SAD.png';

import type { AlertType } from '../../../../alert/duck';

type Props = {
  +goToRedirect: (route: string) => void;
  +setNewAlert: (id: string, alertType: AlertType, message?: string, messageIntl?: string) => void;
};

export default class CheckoutAsyncError extends Component<Props> {
  componentDidMount() {
    const orderId = window.location.pathname.split("/")[4];
    const { goToRedirect } = this.props;
    this.setMessageAlert(orderId);
    goToRedirect(routes.NEW_ORDER.children.CHECKOUT_ORDER.routePath.replace(':orderId', orderId));
  }

  setMessageAlert = (orderId: string) => {
    const { setNewAlert } = this.props;
    const parsedQuery = queryString.parse(window.location.search);
    if (parsedQuery && parsedQuery.dt) {
      const formattedDate = `20${parsedQuery.dt.substr(0, 2)}-${parsedQuery.dt.substr(2, 2)}-${parsedQuery.dt.substr(4, 2)} 
    ${parsedQuery.dt.substr(6, 2)}:${parsedQuery.dt.substr(8, 2)}`
      const alertMsg = `${parsedQuery.msg}
    ${this.context.intl.formatMessage({ id: 'newOrder.checkoutAsyncError.timestamp' })}:
    ${moment(Date.parse(formattedDate)).format('DD MMMM YYYY, HH:mm')}. 
    ${this.context.intl.formatMessage({ id: 'newOrder.checkoutAsyncError.orderId' })}: 
    ${parseInt(orderId.substr(4))}. 
    ${this.context.intl.formatMessage({ id: 'newOrder.checkoutAsyncError.tryPaypal' })}`;
      setNewAlert('checkout', 'error', alertMsg);
    } else {
      setNewAlert('checkout', 'error', undefined, 'httpErrors.post.500');
    }
  }

  render() {
    return (
      <section className={style.safetyPayResponse}>
        <img src={yogiLeg} alt="Qempo"/>
        <FormattedMessage id="newOrder.checkoutAsyncError.title">{
          text => <h2>{text}</h2>
        }</FormattedMessage>
        <FormattedMessage id="newOrder.checkoutAsyncError.subtitle">{
          text => <p>{text}</p>
        }</FormattedMessage>
      </section>);
  }
}

CheckoutAsyncError.propTypes = {
  goToRedirect: PropTypes.func.isRequired,
  setNewAlert: PropTypes.func.isRequired,
};

CheckoutAsyncError.contextTypes = {
  intl: intlShape,
}



// WEBPACK FOOTER //
// ./src/modules/new-order/CheckoutStep/components/CheckoutAsyncResponse/CheckoutAsyncError.jsx